var _ellipse, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLightBulbCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.5004,
    cy: 18.5001,
    rx: 17.1576,
    ry: 17.1576,
    fill: "white",
    stroke: "#ED7000",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6904 27.8645C15.6904 28.3817 16.1097 28.801 16.6269 28.801H17.0951C17.3537 28.801 17.5633 29.0106 17.5633 29.2692C17.5633 29.5278 17.773 29.7374 18.0315 29.7374H18.968C19.2266 29.7374 19.4362 29.5278 19.4362 29.2692C19.4362 29.0106 19.6458 28.801 19.9044 28.801H20.3727C20.8898 28.801 21.3091 28.3817 21.3091 27.8645C21.3091 27.3474 20.8898 26.9281 20.3727 26.9281H16.6269C16.1097 26.9281 15.6904 27.3474 15.6904 27.8645Z",
    fill: "#ED7000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5004 11.945C14.8867 11.945 11.9453 14.8854 11.9453 18.5001C11.9453 20.8249 13.1841 22.9476 15.1292 24.1162C15.4631 24.3168 15.6911 24.6657 15.6911 25.0552C15.6911 25.5722 16.1097 25.9917 16.6275 25.9917H20.3733C20.8912 25.9917 21.3098 25.5722 21.3098 25.0552C21.3098 24.6657 21.5378 24.3168 21.8717 24.1162C23.8167 22.9477 25.0556 20.8258 25.0556 18.5001C25.0556 14.8854 22.1142 11.945 18.5004 11.945ZM20.0606 22.9098C19.6878 23.0419 19.4369 23.3959 19.4369 23.792C19.4369 23.9725 19.2906 24.1188 19.1101 24.1188H17.8908C17.7103 24.1188 17.564 23.9725 17.564 23.792C17.564 23.3949 17.313 23.0419 16.9403 22.9098C15.073 22.2487 13.8182 20.476 13.8182 18.5001C13.8182 15.9183 15.9187 13.8179 18.5004 13.8179C21.0822 13.8179 23.1827 15.9183 23.1827 18.5001C23.1827 20.476 21.9278 22.2487 20.0606 22.9098Z",
    fill: "#ED7000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4364 10.0721V8.1992C19.4364 7.68202 19.0171 7.26276 18.4999 7.26276C17.9827 7.26276 17.5635 7.68202 17.5635 8.1992V10.0721C17.5635 10.5893 17.9827 11.0085 18.4999 11.0085C19.0171 11.0085 19.4364 10.5893 19.4364 10.0721Z",
    fill: "#ED7000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.072 17.5637H8.19914C7.68196 17.5637 7.2627 17.9829 7.2627 18.5001C7.2627 19.0173 7.68196 19.4366 8.19914 19.4366H10.072C10.5892 19.4366 11.0085 19.0173 11.0085 18.5001C11.0085 17.9829 10.5892 17.5637 10.072 17.5637Z",
    fill: "#ED7000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8005 17.5637H26.9277C26.4105 17.5637 25.9912 17.9829 25.9912 18.5001C25.9912 19.0173 26.4105 19.4366 26.9277 19.4366H28.8005C29.3177 19.4366 29.737 19.0173 29.737 18.5001C29.737 17.9829 29.3177 17.5637 28.8005 17.5637Z",
    fill: "#ED7000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4411 12.881L26.9268 11.3949C27.2922 11.0293 27.2921 10.4367 26.9266 10.0712C26.561 9.70575 25.9684 9.70584 25.6029 10.0714L24.1172 11.5575C23.7518 11.9231 23.7519 12.5157 24.1174 12.8812C24.483 13.2466 25.0756 13.2465 25.4411 12.881Z",
    fill: "#ED7000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8821 11.5577L11.3962 10.0718C11.0307 9.70628 10.4381 9.70628 10.0725 10.0718C9.70703 10.4373 9.70703 11.0299 10.0725 11.3955L11.5584 12.8814C11.924 13.2469 12.5166 13.2469 12.8821 12.8813C13.2476 12.5158 13.2476 11.9232 12.8821 11.5577Z",
    fill: "#ED7000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.2627 7.26276H29.7374V29.7374H7.2627V7.26276Z",
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLightBulbCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/light-bulb-circle.8595406b3bc49d57e1111033e319c663.svg";